export const FROZEN_EMPTY_ARRAY = Object.freeze([]);
export const FROZEN_EMPTY_OBJECT = Object.freeze({});
/** Returns a frozen empty array typed as ` T[]`. */ export const getFrozenEmptyArray = ()=>Object.freeze([]);
/** Returns a frozen empty object typed as `T`. */ export const getFrozenEmptyObject = ()=>Object.freeze({});
